import React, {Component} from 'react'
import {ShareButtons} from 'react-share'
import {FaFacebook, FaGooglePlus, FaTwitter, FaLinkedin, FaPinterestP, FaPaperPlane, FaWhatsapp} from '../ReactIcons/icons'

import './SocialShareComponent.css'

class SocialShareComponent extends Component {
  render () {
    const {
      FacebookShareButton,
      GooglePlusShareButton,
      LinkedinShareButton,
      TwitterShareButton,
      PinterestShareButton,
      TelegramShareButton,
      WhatsappShareButton
    } = ShareButtons

    return (
      <div>
        <FacebookShareButton url={this.props.url} title={this.props.title} description={this.props.description}>
          <FaFacebook />
        </FacebookShareButton>
        <GooglePlusShareButton url={this.props.url} title={this.props.title} description={this.props.description}>
          <FaGooglePlus />
        </GooglePlusShareButton>
        <TwitterShareButton url={this.props.url} title={this.props.title} description={this.props.description}>
          <FaTwitter />
        </TwitterShareButton>
        <LinkedinShareButton url={this.props.url} title={this.props.title} description={this.props.description}>
          <FaLinkedin />
        </LinkedinShareButton>
        <PinterestShareButton url={this.props.url} title={this.props.title} description={this.props.description}>
          <FaPinterestP />
        </PinterestShareButton>
        <TelegramShareButton url={this.props.url} title={this.props.title} >
          <FaPaperPlane />
        </TelegramShareButton>
        <WhatsappShareButton url={this.props.url} title={this.props.title} >
          <FaWhatsapp />
        </WhatsappShareButton>
      </div>
    )
  }
}

SocialShareComponent.propTypes = {
  url: React.PropTypes.string.isRequired,
  title: React.PropTypes.string.isRequired,
  description: React.PropTypes.string.isRequired
}

export default SocialShareComponent



// WEBPACK FOOTER //
// ./src/components/Common/SocialShare/SocialShareComponent.js